/**
 * Welche Video-Adresse holt der Reader wirklich vom Server?
 *
 * Getrennt vom Renderer, damit die Regel ohne Browser pruefbar ist — die
 * Geraete-Erkennung bleibt draussen und kommt als `handy` herein.
 *
 * ZWEI FORMEN, die das Backend schickt (s. user-scrollys/video-adresse.ts):
 *
 *   1. `?r=web&v=<id>&vm=<id>`  — TEMPLATES. Am Schreibtisch die Web-Fassung,
 *      am Handy die kleine. Beide Adressen sind ueber `v`/`vm` cache-eindeutig.
 *
 *   2. `?vm=<id>` OHNE `r=`     — PRO-EDITOR-SCROLLYS (Jans Fund 23.09.2026).
 *      Ohne `r=` liefert der Server IMMER das Original — der Autor behaelt am
 *      Schreibtisch also seine eigene Datei. Erst auf dem Handy haengen wir
 *      `r=mobile` an. Wichtig: `v=original` reicht dafuer NICHT — das `v` ist
 *      beim Server nur eine Cache-Kennung, kein Auswahl-Kriterium; mit `r=web`
 *      nimmt er die Web-Fassung, sobald es eine gibt (gemessen an amiri_syrien:
 *      `?r=web&v=original&vm=…` lieferte 2,6 MB MP4 statt des 5,3-MB-Originals).
 *
 * Ohne `vm=` bleibt jede Adresse unveraendert.
 */
export function handyAdresse(url: string, handy: boolean): string {
    if (!url.includes("vm=")) return url;
    if (!handy) return url;
    if (url.includes("r=web")) return url.replace("r=web", "r=mobile");
    // Nur-Handy-Form: bisher ohne jedes `r=`.
    if (/[?&]r=/.test(url)) return url;
    return `${url}${url.includes("?") ? "&" : "?"}r=mobile`;
}
